import { asyncUserRoutes, baseRoutes } from '@/router'
import { isLogin } from '@/utils/auth'
import { useUserStore, usePageStore } from '@/stores/index.js'
import { deepClone } from '@/utils/common.js'

// 当前项目类型是否允许进入该路由（meta.projectTypes 未配置则视为 可访问）
function allowRoute(route) {
  const pageStore = usePageStore()
  let routeProjectTypes
  for (const record of route.matched) {
    if (record.meta?.projectTypes !== undefined) {
      routeProjectTypes = record.meta.projectTypes
    }
  }

  const brandType = pageStore.brandType ?? 1
  return !routeProjectTypes || routeProjectTypes.includes(brandType)
}

export default function usePermission() {
  // 获取全部可访问的路由
  const accessRouter = () => {
    let hasLogin = isLogin()
    if (!hasLogin) {
      return []
    }

    let routes = deepClone(asyncUserRoutes)

    // 根据用户权限进行路由过滤
    const userStore = useUserStore()
    const { userInfo } = userStore
    const role = userInfo?.role

    // 根据角色权限，递归过滤菜单，获取可展示的页面
    const getRoutes = routes => {
      let res = []
      routes.forEach(route => {
        if (route?.meta?.roles && route?.meta?.roles.includes(role)) {
          res.push(route)
        }
        if (route.children) {
          route.children = getRoutes(route.children)
        }
      })
      return res
    }

    routes = getRoutes(routes)
    return routes
  }

  // 获取首个可访问路由
  const getFirstPermissionPage = () => {
    let page = '/login'
    let hasLogin = isLogin()
    if (hasLogin) {
      const routes = accessRouter()
      page = getFirstAccessibleRoute(routes)
      console.log('----首页，可访问路由----', page)
    }

    return page
  }

  // 递归获取首页完整路由地址
  const getFirstAccessibleRoute = routes => {
    let path = ''
    if (!routes || routes.length === 0) {
      return path
    }
    path = routes[0].path
    if (routes[0].children && routes[0].children.length > 0) {
      path = path + '/' + getFirstAccessibleRoute(routes[0].children)
    }
    return path
  }

  // 判断路由是否可访问
  const isAccessible = route => {
    const whiteNames = baseRoutes.map(p => p.name)
    const role = useUserStore().userInfo?.role
    const hasRole = route?.meta?.roles && route?.meta?.roles.includes(role)
    // 白名单或角色通过后再校验项目类型
    return (whiteNames.includes(route.name) || hasRole) && allowRoute(route)
  }

  return {
    accessRouter,
    getFirstPermissionPage,
    isAccessible
  }
}
